import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getCallFlags(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getCallFlags", {
      params: requestObject,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function getCallFlagsSelected(convID, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.get(`api/getCallFlagsSelected/${convID}`, {
      params: { userKey },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function getCallFlagsSummary(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getCallFlagsSummary", {
      params: requestObject,
      headers: {
        "x-user-key": requestObject.userKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function createCallFlagsSelected(requestData) {
  validateUserKey(requestData.UserKey);
  try {
    const { data } = await apiClient.post("api/createCallFlagsSelected", requestData, {
      headers: {
        "x-user-key": requestData.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function removeCallFlagsSelected(requestData) {
  validateUserKey(requestData.UserKey);
  try {
    const { data } = await apiClient.patch("api/removeCallFlagsSelected", requestData, {
      headers: {
        "x-user-key": requestData.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function reviewCallFlagsSelected(requestData) {
  validateUserKey(requestData.UserKey);
  try {
    const { data } = await apiClient.patch("api/reviewCallFlagsSelected", requestData, {
      headers: {
        "x-user-key": requestData.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function reviewAllCallFlags(requestData) {
  validateUserKey(requestData.UserKey);
  try {
    const { data } = await apiClient.patch("api/reviewAllCallFlags", requestData, {
      headers: {
        "x-user-key": requestData.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
